import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import LanguagePicker from "../../components/LaguagePicker";
import LanguageFlag from "../../components/LanguageFlag";
import { loadRestaurant } from "../../redux/actions/baseActions";
import { withTranslation } from "react-i18next";
import { DeliveryType } from "../../constants/deliveryTypes";
import { getImageUrl } from "../../api/iposApi";
import { convertDotNetTimeToMomentDate } from "../../helpers/dateTime";
import IPosModal from "../../IPosModal";
import logo from "../../assets/img/logo/i-love-ipos.png";
import MobileMenu from "./MobileMenu";
import { isMobileAndTablet } from "../../helpers/common";
import { getLanguageById } from "../../helpers/language";

const TopNavigation = ({
  t,
  branchInfo,
  currentDeliveryType,
  currentLanguageId,
  empty,
  shorHeader = false,
}) => {
  const history = useHistory();

  const openBranchInfo = () => {
    IPosModal.branchInfo({
      branchInfo: branchInfo,
      t: t,
      onOk: () => {},
    });
  };

  const goToHome = () => {
    if (shorHeader) {
      return;
    }
    IPosModal.confirmation({
      title: t("dialogs.redirect_to_home_title"),
      message: t("dialogs.redirect_to_home_description"),
      okButtonText: t("buttons.ok"),
      cancelButtonText: t("buttons.cancel"),
      onOk: () => {
        const lang = getLanguageById(currentLanguageId);
        if (branchInfo && branchInfo.branch_guid_code) {
          history.push(`/${branchInfo.branch_guid_code}/type?lang=${lang}`);
        } else {
          history.push("/");
        }

        window.location.reload();
      },
      onClose: () => {
        return;
      },
    });
  };

  const onSuccessPayment = () => {
    IPosModal.alert({
      title: t('order.submit.success_title'),
      message: t('order.submit.success_message') + t('order.submit.smile_message'),
      okButtonText: t('buttons.ok'),
      iconName: 'check-circle',
      closeOnBodyClick: true,
      onOk: () => {
      }
    }, {modalClassName: 'confirmation-modal success-payment'});
  };

  const isMobile = isMobileAndTablet();
  const branchWazeLink =
    branchInfo.latitude && branchInfo.longitude
      ? `https://www.waze.com/ul?ll=${branchInfo.latitude}%2C${branchInfo.longitude}&navigate=yes&zoom=17`
      : `https://waze.com/ul?q=${branchInfo.Address}&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location`;

  return (
    <section id="topNavigation" className="top-navigation">
      <nav className="navbar navbar-default" role="navigation">
        <div className="container ">
          <div className="navbar-header">
            {!shorHeader && <MobileMenu t={t} />}
            {!shorHeader && branchInfo.use_pin_pad_flg === 1 && (
              <div className="mobile-header-language-flags visible-xs-inline-block">
                <LanguageFlag t={t} />
              </div>
            )}
            <a className="navbar-brand go-home-btn" onClick={goToHome}>
              <img
                src={empty ? logo : getImageUrl(branchInfo.LogoImageName)}
                className="img-responsive"
                alt="iPos Web Delivery"
              />
            </a>
          </div>

          <div
            className="collapse navbar-collapse"
            id="top-menu-collapse"
          >
            {!shorHeader && (!empty || !isMobile) && (
              <>
                <div className="nav navbar-nav navbar-left branch-info hidden-xs">
                  <FontAwesomeIcon icon={["fab", "waze"]} />
                  <a target={"blank"} href={branchWazeLink}>
                    {branchInfo.Address}
                  </a>
                </div>
                <div className="nav navbar-nav navbar-left branch-info hidden-xs">
                  <FontAwesomeIcon icon="phone" />
                  <a href={`tel:${branchInfo.Phone}`}>{branchInfo.Phone}</a>
                </div>

                <div
                  className="nav navbar-nav navbar-left branch-info hidden-xs"
                  data-tip
                  data-for="working-hours"
                >
                  <FontAwesomeIcon icon="clock" />
                </div>

                <div
                  className="nav navbar-nav navbar-left branch-info branch-info-open-popup hidden-xs"
                  onClick={openBranchInfo}
                >
                  <FontAwesomeIcon icon="info-circle" />
                </div>

                <div className="nav navbar-nav navbar-left branch-info hidden-xs">
                  {(currentDeliveryType === DeliveryType.TA ||
                    currentDeliveryType === DeliveryType.EAT_IN) &&
                    t("delivery_type_switcher.ta.title")}
                  {currentDeliveryType === DeliveryType.DELIVERY &&
                    `${t("delivery_type_switcher.delivery.title")} (${
                      branchInfo.DeliveryTime
                    } min) `}
                </div>
              </>
            )}

            {branchInfo.use_pin_pad_flg === 0 && (
              <div className="nav navbar-nav navbar-right hidden-xs">
                <LanguagePicker />
              </div>
            )}
            {branchInfo.use_pin_pad_flg === 1 && (
              <div className="nav navbar-nav navbar-right hidden-xs">
                <LanguageFlag t={t} />
              </div>
            )}
            {!shorHeader && (!empty || !isMobile) && (
              <div className="nav navbar-nav navbar-right hidden-xs login-btn">
                <a>{t("login")}</a>
              </div>
            )}
          </div>
        </div>
      </nav>
      {!shorHeader && !empty && (
        <ReactTooltip id="working-hours" aria-haspopup="true">
          <div className={"working-hours-title"}>
            {t("working_time.working_hours")}
          </div>
          <ul className="working-hours-list">
            {branchInfo.DeliveryTimes &&
              branchInfo.DeliveryTimes.map((deliveryTime) => (
                <li key={deliveryTime.delivery_time_id}>
                  <i className="fa fa-clock-o" />
                  <span className="clock">
                    {moment().day(deliveryTime.day_of_week).format("dddd")}
                  </span>
                  <span className="bold clock">
                    {!deliveryTime.start_dt && !deliveryTime.end_dt
                      ? t("working_time.closed")
                      : `${convertDotNetTimeToMomentDate(
                          deliveryTime.start_dt
                        ).format("HH:mm")}
                  -
                     ${convertDotNetTimeToMomentDate(
                       deliveryTime.end_dt
                     ).format("HH:mm")}`}
                  </span>
                </li>
              ))}
          </ul>
        </ReactTooltip>
      )}
    </section>
  );
};

const mapStateToProps = (state) => {
  const { branchInfo, currentDeliveryType, currentLanguageId } = state;

  return {
    branchInfo,
    currentDeliveryType,
    currentLanguageId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadRestaurant,
    },
    dispatch
  );

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TopNavigation)
);
